import { styled } from '@mui/material/styles';
import { AppBar, Toolbar } from '@mui/material';
import cssStyles from '../../../utils/cssStyles';

const HEADER_HEIGHT = '82px';

const RootStyle = styled(AppBar, {
  shouldForwardProp: (prop) =>
    prop !== 'isCollapse' && prop !== 'isOffset' && prop !== 'verticalLayout',
})(({ theme }) => ({
  ...cssStyles(theme).bgBlur(),
  boxShadow: 'none',
  height: HEADER_HEIGHT,
  zIndex: 1000,
  transition: theme.transitions.create(['width', 'height'], {
    duration: theme.transitions.duration.shorter,
  }),
  width: '100%',
}));

export default function DashboardHeader() {
  return (
    <RootStyle>
      <Toolbar
        sx={{
          height: HEADER_HEIGHT,
          width: '100%',
          background: 'linear-gradient(to right, #FFA285, #FFC685)',
        }}
      />
    </RootStyle>
  );
}
